import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import PageListItem from './PageListItem';

const renderPages = (pages, searchQuery) =>
  pages
    .map(item => (
      <PageListItem
        key={item.getIn(['item', 'id'])}
        title={item.getIn(['item', 'fields', 'title'])}
        description={item.getIn(['item', 'fields', 'introduction'])}
        url={item.getIn(['item', 'url'])}
        searchQuery={searchQuery}
      />
    ))
    .toArray();

const PageList = props => {
  const pages = renderPages(props.pages, props.searchQuery);
  return <div>{pages}</div>;
};

PageList.defaultProps = {
  pages: List(),
  searchQuery: null
};

PageList.propTypes = {
  pages: PropTypes.instanceOf(List),
  searchQuery: PropTypes.string
};

export default PageList;



// WEBPACK FOOTER //
// ./src/components/PageList.js